import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  private brands$: Promise<any> | undefined;
  private relatedHostbrands$: Promise<any> | undefined;
  private categories$: Promise<any> | undefined;

  constructor(
    private config: ConfigService,
    private http: HttpClient
  ) { }

  async getAllBrands(): Promise<any> {
    const url = `${this.config.API_BASE}/api/v1/search`;
    const params = {
      keyword: 'All Brands',
      offset: 0,
      limit: 100,
    };

    this.brands$ = this.brands$ || lastValueFrom(this.http.get(url, { params }));
    return this.brands$;
  }

  async getBrandByStoreId(storeId: any): Promise<any> {
    const url = `${this.config.API_BASE}/api/v1/store/storeAssociatedBrands/${storeId}`;
    const params = {};

    this.relatedHostbrands$ = this.relatedHostbrands$ || lastValueFrom(this.http.get(url, { params }));
    return this.relatedHostbrands$;
  }



  getAllCategories(): Promise<any> {
    const url = `${this.config.API_BASE}/api/v1/search`;
    const params = {
      keyword: 'All Categories',
      offset: 0,
      limit: 100,
    };

    this.categories$ = this.categories$ || lastValueFrom(this.http.get(url, { params }));
    return this.categories$;
  }
}
